export default "__VITE_ASSET__0208a02e__"